export default {
    SET_EXPANDED_DETAILS: 'SET_EXPANDED_DETAILS'
}